import type { PackageTag } from "@przezmorze/api-types";

/**
 * Converts form-state tags (plain `category: string`) into the wire request shape.
 *
 * `TagSelect` only ever offers categories from the trip tag dictionary, so the cast is safe; the backend
 * rejects any other category with a 400.
 */
export function toPackageTagRequest(tags: { category: string; value: string }[]): PackageTag[] {
  return tags.map((t) => ({ category: t.category as PackageTag["category"], value: t.value }));
}
